import { css } from 'emotion';

const kProgressCicleRadius = 12.0;
const kMarginBig = 16.0;

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    cursor: pointer;
  `,
  centerContent: {
    display: 'flex',
    flexDirection: 'column'
  },
  cardDuration: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    float: 'left',
    marginTop: '10px',
    marginLeft: '53px',
    marginBottom: kMarginBig
  },
  iconStyle: {
    width: 15,
    height: 15
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
  },
  cardName: {
    fontSize: 14,
    lineHeight: '19px',
    minWidth: '210px',
    overflow: 'hidden',
    cursor: 'pointer',
    alignItems: 'center',
    maxWidth: '210px'
  },
  rightContent: {
    marginLeft: 'auto'
  },
  cardNameText: {
    marginRight: '5px'
  },
  IconColor: '#ffffff',
  circleIcon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-9px',
    marginLeft: '-9px'
  },
  circle: {
    width: 2 * kProgressCicleRadius,
    height: 2 * kProgressCicleRadius,
    borderRadius: '50%',
    marginRight: '12px',
    border: '1px solid rgba(199,203,207,0.7)',
    flexShrink: '0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute'
  },
  topCircle: {
    width: '24px',
    height: '12px',
    borderRadius: '30px 30px 0px 0px'
  },
  bottomCircle: {
    width: '24px',
    height: '12px',
    borderRadius: '0 0px 30px 30px'
  },
  timeLabel: {
    display: 'inline-block',
    fontSize: '12px',
    color: '#8392a7',
    width: 'auto',
    foat: 'left',
    paddingLeft: '6px',
    letterSpacing: '-0.07px'
  },
  optioalLabel: {
    display: 'inline-block',
    fontStyle: 'italic',
    fontSize: '12px',
    color: 'inherit',
    width: 'auto',
    foat: 'left',
    paddingLeft: '3px',
    letterSpacing: '-0.07px'
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    marginRight: '14px'
  },
  completedIcon: {
    background: '#54d566',
    borderRadius: '50%',
    padding: '2px'
  },
  isSyncCompletedIcon: {
    background: 'red',
    borderRadius: '50%',
    padding: '2px'
  },
  failedIcon: {
    background: '#ff3a3a',
    borderRadius: '50%',
    padding: '2px',
    textAlign: 'center',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '12px'
  },
  awaitingIcon: {
    background: '#f7981c',
    borderRadius: '50%',
    padding: '2px'
  },
  participantProgressContainer: css`
    margin-top: 2px;
  `,
  usersIcon: theme => css`
    width: 14px;
    height: 14px;
    margin-right: 6px;
    stroke: #8392a7;

    .cardInfoContainer.active & {
      stroke: white;
    }
    .cardInfoContainer:hover:not(.active) & {
      stroke: ${theme.color.grey1};
    }
  `,
  completedUsersText: css`
    font-size: 12px;
    margin-top: 2px;
  `
};

export default styles;
